var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "bbf_plusicon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C6 0.895431 6.89543 0 8 0C9.10457 0 10 0.895431 10 2V14C10 15.1046 9.10457 16 8 16C6.89543 16 6 15.1046 6 14V2Z",
    fill: "#6363FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C0.895431 10 -1.31719e-08 9.10457 0 8C1.31719e-08 6.89543 0.895431 6 2 6H14C15.1046 6 16 6.89543 16 8C16 9.10457 15.1046 10 14 10H2Z",
    fill: "#6363FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e83a0e89b6d2dbe32d5aa09d74733e69.svg";
export { ForwardRef as ReactComponent };